import { render, staticRenderFns } from "./BollettazioneElenco.vue?vue&type=template&id=677e09f8"
import script from "./BollettazioneElenco.vue?vue&type=script&lang=js"
export * from "./BollettazioneElenco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports